import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-price-edit-shell',
  templateUrl: './product-price-edit-shell.component.html',
  styleUrls: ['./product-price-edit-shell.component.scss']
})
export class ProductPriceEditShellComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
